import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SupportAccountDataSourceService {

  public accountSubject = new BehaviorSubject<any>([]);

  public accountCountSubject = new BehaviorSubject<number>(0);

  cast = this.accountCountSubject.asObservable();

  public loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  constructor() { }

  setAccountData(data) {
    this.accountSubject.next(data);

  }
  setAccountCount(data) {
    this.accountCountSubject.next(data);
  }

}
